const ro = {
    'Manage your objectives': 'Administrează obiectivele',
    'FILTER COUNSELORS': 'Filtrare Consilieri',
    'ADD OBJECTIVE': 'Adaugă obiectiv',
    'VP Deliveries': 'Livrări VP',
    'VU Deliveries': 'Livrări VU',
    'Total Orders': 'Comenzi Totale',
    'Total Deliveries': 'Livrări totale',
    'PF Orders': 'Comenzi PF',
    'PJ Orders': 'Comenzi PJ',
    'PF Deliveries': 'Livrări PF',
    'PJ Deliveries': 'Livrări PJ',
    'Electric Deliveries': 'Livrări Electrice',
    'Electric Orders': 'Comenzi Electrice',
    'Thermic Orders': 'Comenzi Termice',
    'Hybrid Orders': 'Comenzi Hibrid',
    'Add objective': 'Adaugă obiectiv',
    'Filter objectives': 'Filtrare obiective',
    Quarter: 'Trimestru',
    Month: 'Luna',
    'Start Date': 'Data de început',
    'End Date': 'Data de sfârșit',
    'Add objectives': 'Adaugă obiective',
    'The name of the counselor is mandatory!': 'Numele consilierului este obligatoriu',
    'The number of the PF Deliveries is mandatory!': 'Numărul de livrări PF este obligatoriu!',
    'The number of the PJ Deliveries is mandatory!': 'Numărul de livrări PJ este obligatoriu!',
    'The number of the Electric Deliveries is mandatory!': 'Numărul de livrări electrice este obligatoriu!',
    'The number of the Electric Orders is mandatory!': 'Numărul de comenzi electrice este obligatoriu!',
    'The number of the Thermic Orders is mandatory!': 'Numărul de comenzi termice este obligatoriu!',
    'The number of the Hybrid Orders is mandatory!': 'Numărul de comenzi hibrid este obligatoriu!',
    'The number of the total deliveries is mandatory!': 'Numărul de livrări totale este obligatoriu',
    'The number of the PF Orders is mandatory!': 'Numărul de comenzi PF este obligatoriu',
    'The number of the PJ Orders is mandatory!': 'Numărul de comenzi PJ este obligatoriu',
    'The number of the VP Deliveries is mandatory!': 'Numărul de livrări VP este obligatoriu',
    'The number of the VU Deliveries is mandatory!': 'Numărul de livrări VU este obligatoriu',
    'Objective Name': 'Denumire Obiectiv',
    'Are you sure you want to delete this objective?': 'Sunteți sigur că doriți să ștergeți acest obiectiv?',
    'The objective was successfully deleted!': 'Obiectivul a fost șters cu succes!',
    'Something went wrong!': 'A intervenit o eroare!',
    'The objective was succesfully updated': 'Obiectivul a fost actualizat cu succes!',
    'An error ocurred. Please try again': 'A intervenit o eroare. Încercați din nou!',
    'The objective was succesfully created': 'Obiectivul a fost creat cu succes!',
    'Choose a valid date type!': 'Alegeti o data valida!',
    'Search counselor': 'Caută consilier',
    'The color was succesfully deleted': 'Culoarea a fost ștearsă cu succes',
    'Engine deleted succesfully': 'Motorizarea a fost ștearsă cu succes',
    'Are you sure you want to delete this color?': 'Sunteți sigur că doriți să ștergeți această culoare?',
    'Are you sure you want to delete this engine?': 'Sunteți sigur că doriți să ștergeți această motorizare?',
    'Engine added succesfully': 'Motorizare adaugată cu succes',
    'Color added succesfully': 'Culoare adăugată cu succes',
    'The client has been added succesfully': 'Clientul a fost adăugat cu succes',
    'Search objective': 'Caută obiectiv',
    'This value should be a number!': 'Această valoare trebuie să fie un număr!',
    'FILTER OBJECTIVES': 'FILTRARE OBIECTIVE',
    'REMOVE FILTERS': 'Șterge Filtre',
    'This value must be positive!': 'Această valoare trebuie să fie pozitivă!',
    '* Here are displayed only the objectives on the current month!':
        '* Aici sunt afișate doar obiectivele pentru luna curentă!',
    'The objective could not be added! The counselor already has an objective for this month!':
        'Obiectivul nu a putut fi adăugat! Consilierul are deja un obiectiv pentru luna aceasta!',
};

export default { ro };
